<template>
  <div class="container-fluid">
    <Card>
      <template slot="header"
        ><h3>گزارش بازاریابی</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-lg-4 col-12 no-print">
            <small>روش بازاریابی</small>
            <SearchableCombo
              :edit="false"
              :grp="9"
              :code="null"
              @ResultCombo="GetResultRaveshBazaryabi"
              @deleteSelected="deleteRaveshBazaryabi"
              :rownumintable="3"
              :ActiveDelete="true"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'RaveshBazarayabi'"
              :keyItem="'RaveshBazarayabi'"
              :disabled="false"
              :defaultvalue="DataAxios.ArryfildValue.tblCombogrp9RaveshBazaryabi"
            >
            </SearchableCombo>
          </div>
          <div class="col-lg-4 col-12 no-print">
            <small>منبع</small>
            <SearchableCombo
              v-if="$store.state.renderComponentCombo"
              :edit="false"
              :grp="22"
              :code="DataAxios.ArryfildValue.tblCombogrp9RaveshBazaryabi"
              @ResultCombo="GetResultManbaBazaryabi"
              @deleteSelected="deleteCombogrp9RaveshBazaryabi"
              :rownumintable="3"
              :action="'TblCrmCombo/GetComboByFilter'"
              :method="'POST'"
              :ActiveDelete="true"
              :idinput="'ManbaBazaryabi'"
              :keyItem="'ManbaBazaryabi'"
              :disabled="DataAxios.ArryfildValue.tblCombogrp9RaveshBazaryabi == null && $route.params.Status != 'Edit'"
              :defaultvalue="DataAxios.ArryfildValue.tblCombogrp22ManbaBazaryabi"
            >
            </SearchableCombo>
          </div>
          <div class="col-lg-4 col-12 no-print">
            <small id="LbltblCombogrp3GroupHadaf"> گروه هــدف </small>
            <SearchableCombo
              :edit="false"
              :ActiveDelete="true"
              :grp="3"
              :code="null"
              @ResultCombo="GetResultGroupHadaf"
              @deleteSelected="deleteGroupHadaf"
              :rownumintable="3"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'GroupHadaf'"
              :keyItem="'GroupHadaf'"
              :disabled="false"
              :defaultvalue="DataAxios.ArryfildValue.tblCombogrp3Group"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-4 col-12 no-print">
            <small id="LbltblCombogrp4AvalinHadafBazaryabi"> هــدف </small>
            <SearchableCombo
              :edit="false"
              :ActiveDelete="true"
              :grp="4"
              :code="null"
              @ResultCombo="GetResultHadaf"
              @deleteSelected="deleteGetResultHadaf"
              :rownumintable="3"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'Hadaf'"
              :keyItem="'Hadaf'"
              :disabled="false"
              :defaultvalue="DataAxios.ArryfildValue.tblCombogrp4AvalinHadafBazaryabi"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-4 col-12 no-print">
            <small :id="'Lbl' + 'tblCombogrp10state'"> استــان </small>
            <SearchableCombo
              :edit="false"
              :grp="10"
              :code="null"
              @ResultCombo="GetResultState"
              @deleteSelected="deleteResultState"
              :rownumintable="3"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :idinput="'State'"
              :keyItem="'State'"
              :ClassProps="'required'"
              :disabled="false"
              :defaultvalue="DataAxios.ArryfildValue.tblCombogrp10state"
              :ActiveDelete="true"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-4 col-12 no-print">
            <small :id="'Lbl' + 'tblCombogrp11Shahr'"> شـهر </small>
            <SearchableCombo
              v-if="$store.state.renderComponentGrid"
              :edit="false"
              :grp="11"
              :code="DataAxios.ArryfildValue.tblCombogrp10state"
              @ResultCombo="GetResultCity"
              @deleteSelected="deleteResultCity"
              :rownumintable="3"
              :action="'TblCrmCombo/GetComboByParentId'"
              :method="'POST'"
              :idinput="'City'"
              :keyItem="'City'"
              :ClassProps="'required'"
              :disabled="DataAxios.ArryfildValue.tblCombogrp10state == 0"
              :defaultvalue="DataAxios.ArryfildValue.tblCombogrp11Shahr"
              :ActiveDelete="true"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-4 col-12 no-print">
            <small id="LbltblCombogrp37AxarinVazeit"> آخریــن وضعــیت </small>
            <!-- <SearchableCombo :edit="false" :grp="37" :code="null" @ResultCombo="GetResultVaziat" :rownumintable="3" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'Vaziat'" :keyItem="'Vaziat'" :disabled="false"> </SearchableCombo> -->
            <div dir="rtl" class="no-print">
              <treeselect
                name="demo"
                :multiple="multiple"
                :clearable="clearable"
                :searchable="searchable"
                :disabled="disabled"
                :open-on-click="openOnClick"
                :open-on-focus="openOnFocus"
                :clear-on-select="clearOnSelect"
                :close-on-select="closeOnSelect"
                :always-open="alwaysOpen"
                :append-to-body="appendToBody"
                :options="options"
                v-model="value"
                :normalizer="normalizer"
                @select="ItemSelected"
                @deselect="ItemDeselect"
              >
                <label slot="option-label" slot-scope="{ labelClassName, node }" :class="labelClassName">{{ node.label }}</label>
              </treeselect>
            </div>
          </div>
          <div class="col-md-4 col-12 no-print">
            <div class="custom-control form-control custom-switch mt-4">
              <small id="lblShowInSlides">فقط مشتریان</small>
              <input type="checkbox" class="custom-control-input InputText" id="OnlyCustomers" v-model="DataAxios.ArryfildValue.OnlyCustomers" />
              <label class="custom-control-label mr-2" for="OnlyCustomers"> </label>
            </div>
          </div>
          <div class="col-md-4 col-12 no-print">
            <small id="LbltblCombogrp37AxarinVazeit">وضعیت بایگانی</small>
            <div class="form-control">
              <input type="radio" name="Archive" value="null" id="All" v-model="DataAxios.ArryfildValue.Archive" />
              <label class="mx-2" for="All">همه</label>
              <input type="radio" name="Archive" value="true" id="Not" v-model="DataAxios.ArryfildValue.Archive" />
              <label class="mx-2" for="Not">بایگانی شده</label>
              <input type="radio" name="Archive" value="false" id="yes" v-model="DataAxios.ArryfildValue.Archive" />
              <label class="mx-2" for="yes">بایگانی نشده</label>
            </div>
          </div>
          <div class="col-md-4 col-12 no-print">
            <small>نوع مجوز</small>
            <SearchableCombo
              :edit="false"
              :grp="35"
              :code="DataAxios.ArryfildValue.grp35NoeMojavezYaEstandard"
              @ResultCombo="GetResultgrp35NoeMojavezYaEstandard"
              @deleteSelected="deletegrp35NoeMojavezYaEstandard"
              :rownumintable="3"
              :action="'TblCrmCombo/GetComboById'"
              :method="'POST'"
              :ActiveDelete="true"
              :idinput="'grp35NoeMojavezYaEstandard'"
              :keyItem="'grp35NoeMojavezYaEstandard'"
              :defaultvalue="DataAxios.ArryfildValue.grp35NoeMojavezYaEstandard"
            >
            </SearchableCombo>
          </div>
          <div class="col-md-4 col-12">
            <button class="btn btn-success w-100 mt-4 no-print" @click="BuildReport">ساخت گزارش</button>
          </div>
          <!-- <div class="col-md-4 col-12">
            <button v-if="IsPrint" class="btn btn-warning w-100 mt-4 no-print" type="button" @click="PrintPage"> 
              <span class="mr-2" style="font-size: 17px !important">چاپ گزارش</span>
            </button>

          </div> -->

          <div class="col-12">
            <br />
            <hr />
            <BnpGrid Selectable :Sortable="true" :action="true" :excel="true" :propsRows="propsRows" :propsColumn="propsColumn" :hasRowNum="true" :pagenum="20" :IsReport="true" :HeaderReport="'گزارش  بازاریابی'" :ListCommaReport="[]" v-if="$store.state.renderComponentGrid">
              <template slot="action-slot" slot-scope="props">
                <a href="javascript:;" class="mr-2 badge" data-title="مشاهده جزئیات" @click="$FindeCustomerById('DetailCustomer', props.props.id, false, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.id, false, $event)"
                  ><h6><span class="fas fa-eye font-weight-bold hover-danger"></span></h6
                ></a>
                <a href="javascript:;" class="mr-2 badge" data-title="نامه ها و فایلها" @click="$FindeCustomerById('DetailCustomer', props.props.id, 6, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.id, 6, $event)"
                  ><h6><span class="fad fa-mail-bulk hover-warning"></span></h6
                ></a>
                <a href="javascript:;" class="mr-2 badge" data-title="دمو و حضور" @click="$FindeCustomerById('DetailCustomer', props.props.id, 7, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.id, 7, $event)"
                  ><h6><span class="fad fa-business-time hover-info"></span></h6
                ></a>
                <a href="javascript:;" class="mr-2 badge" data-title="هشدارها" @click="$FindeCustomerById('DetailCustomer', props.props.id, 1, $event)" @click.middle="$FindeCustomerById('DetailCustomer', props.props.id, 1, $event)"
                  ><h6><span class="fas fa-bell t hover-danger"></span></h6
                ></a>
              </template>
              <template slot="customerName" slot-scope="props">
                <span> {{ props.props.customerName }}</span> <span v-if="props.props.baygani">(بایگانی شده)</span>
              </template>
              <template slot="totallScore" slot-scope="props">
                <!-- <b-progress :value="props.props.TotallScore" :max="propsRows[0].TotallScore" variant="warning"  show-progress animated></b-progress> -->
                <b-progress class="sidebarProgress mt-1" :title="props.props.TotallScore" show-value :variant="'warning'" :value="props.props.totallScore" :max="propsRows[0].totallScore" />
              </template>
            </BnpGrid>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect'
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      IsPrint: false,
      multiple: true,
      clearable: false,
      searchable: true,
      disabled: false,
      openOnClick: true,
      openOnFocus: false,
      clearOnSelect: true,
      closeOnSelect: false,
      alwaysOpen: false,
      appendToBody: false,
      value: [],
      options: [],
      DataAxios: {
        Action: 'Reports/mrketingReport',
        Method: 'POST',
        ArryfildValue: {
          tblCombogrp9RaveshBazaryabi: null,
          tblCombogrp22ManbaBazaryabi: null,
          tblCombogrp3Group: null,
          tblCombogrp4AvalinHadafBazaryabi: null,
          grp35NoeMojavezYaEstandard: null,
          tblCombogrp11Shahr: null,
          tblCombogrp10state: null,
          tblCombogrp37AxarinVazeit: null,
          Archive: null,
          OnlyCustomers: true,
        },
      },
      propsColumn: [
        { name: 'customerCode', label: 'کد', visibility: true },
        { name: 'customerName', label: 'نام مشتری', visibility: true },
        { name: 'codeBazaryabi', label: ' کد بازاریابی', visibility: true },
        { name: 'totallScore', label: 'امتیاز مشتری', visibility: true },
        { name: 'tblCombogrp37AxarinVazeitName', label: 'وضعیت فعالیت', visibility: true },
      ],
      propsRows: [],
    }
  },
  components: { Card, SearchableCombo, BnpGrid, Treeselect },
  methods: {
    GetResultRaveshBazaryabi(data) {
      if (data.id != null) {
        this.RaveshBazaryabi = data.id
        this.DataAxios.ArryfildValue.tblCombogrp9RaveshBazaryabi = data.id
        this.$store.state.renderComponentCombo = false
        this.$nextTick(() => {
          this.$store.state.renderComponentCombo = true
        })
      }
    },
    deleteRaveshBazaryabi() {
      this.DataAxios.ArryfildValue.tblCombogrp9RaveshBazaryabi = null
    },
    GetResultgrp35NoeMojavezYaEstandard(data) {
      if (data.id != null) {
        this.DataAxios.ArryfildValue.grp35NoeMojavezYaEstandard = data.id
        this.$store.state.renderComponentCombo = false
        this.$nextTick(() => {
          this.$store.state.renderComponentCombo = true
        })
      }
    },
    deletegrp35NoeMojavezYaEstandard() {
      this.DataAxios.ArryfildValue.grp35NoeMojavezYaEstandard = null
    },
    GetResultManbaBazaryabi(data) {
      if (data.id != null) {
        this.DataAxios.ArryfildValue.tblCombogrp22ManbaBazaryabi = data.id
      }
    },
    deleteCombogrp9RaveshBazaryabi() {
      this.DataAxios.ArryfildValue.tblCombogrp22ManbaBazaryabi = null
    },
    GetResultGroupHadaf(data) {
      if (data.id != null) {
        this.DataAxios.ArryfildValue.tblCombogrp3Group = data.id
      }
    },
    deleteGroupHadaf() {
      this.DataAxios.ArryfildValue.tblCombogrp3Group = null
    },
    GetResultHadaf() {
      this.DataAxios.ArryfildValue.tblCombogrp3Group = null
    },
    GetResultHadaf(data) {
      if (data.id != null) {
        this.DataAxios.ArryfildValue.tblCombogrp4AvalinHadafBazaryabi = data.id
      }
    },
    deleteGetResultHadaf() {
      this.DataAxios.ArryfildValue.tblCombogrp4AvalinHadafBazaryabi = null
    },
    GetResultState(data) {
      this.DataAxios.ArryfildValue.tblCombogrp10state = data.id
      this.$store.state.renderComponentGrid = false
      this.$nextTick(() => {
        this.$store.state.renderComponentGrid = true
      })
    },
    deleteResultState() {
      this.DataAxios.ArryfildValue.tblCombogrp10state = null
    },
    GetResultCity(data) {
      var index = Number(data.key.replace('City', ''))
      this.DataAxios.ArryfildValue.tblCombogrp11Shahr = data.id
    },
    deleteResultCity() {
      this.DataAxios.ArryfildValue.tblCombogrp11Shahr = null
    },
    BuildReport() {
      // console.log(this.DataAxios.ArryfildValue)
      this.DataAxios.ArryfildValue.tblCombogrp37AxarinVazeit = this.value
      this.$store.state.marketingReportFilter = this.DataAxios.ArryfildValue
      this.$PostData(this.DataAxios).then((result) => {
        if (result.length > 0) {
          this.IsPrint = true
          this.propsRows = result
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        } else {
          this.propsRows = []
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
          this.$mySweetDefaultTost('عملیات ناموفق', 'اطلاعاتی وجود ندارد', 'info', 2000)
        }
      })
    },
    // OnDetail(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id } })
    // },
    // OnAndicator(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id, activeTab: 6 } })
    // },
    // OnDemo(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id, activeTab: 7 } })
    // },
    // OnTask(data) {
    //   this.$router.push({ name: 'DetailCustomer', params: { tblCustomerId: data.id, activeTab: 1 } })
    // },
    ItemSelected(node) {
      this.value.push(node.id)
    },
    ItemDeselect(node) {
      for (let index = 0; index < this.value.length; index++) {
        if (this.value[index] == node.id) {
          this.value.splice(index, 1)
        }
      }
    },
    PrintPage: function () {
      window.print()
    },
  },
  mounted() {
    var DataAxios = { Method: 'POST', Action: 'TblCrmCombo/GetComboById', ArryfildValue: { Id: 37 } }
    this.$PostData(DataAxios).then((result) => {
      this.options = result
    })
    if (this.$store.state.marketingReportFilter != null && this.$store.state.marketingReportFilter != {}) {
      this.DataAxios.ArryfildValue = this.$store.state.marketingReportFilter
      this.BuildReport()
    }
  },
}
</script>
<style scoped>
@media print {
  .no-print {
    display: none;
  }
}
</style>
